/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestMaxOutputFilesSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_MAX_OUTPUT_FILES_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class NewAutoTestMaxOutputFilesSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestMaxOutputFilesSizeSettingParser.decode(input).map(res => new NewAutoTestMaxOutputFilesSizeSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestMaxOutputFilesSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestMaxOutputFilesSizeSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestMaxOutputFilesSizeSettingParser.schema();
    }
}
